import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", ...rest }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
